import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { variables } from '../variables';
import { offerFormatting } from '../combo-offer/combo-offer';

@customElement('apt-standard-offer')
export class StandardOffer extends LitElement {
  @property({})
  value = 'dollarMarketShare';

  static override get styles() {
    return [variables, offerFormatting];
  }

  override render() {
    return html`<div class="header">Select Target Option</div>
      <div class="option">
        <input
          type="radio"
          name="type"
          id="dollarMarketShare"
          value="dollarMarketShare"
          @click="${this.radioButtonHandler}"
          checked
        />
        <div class="description">
          <label for="dollarMarketShare">Spend Market Share</label><br />
          Buyer commits this percentage of their spend to the seller.
        </div>
      </div>
      <div class="option">
        <input
          type="radio"
          name="type"
          id="unitMarketShare"
          value="unitMarketShare"
          @click="${this.radioButtonHandler}"
        />
        <div class="description">
          <label for="unitMarketShare">Unit Market Share</label><br />
          Buyer commits this percentage of their units to the seller.
        </div>
      </div>
      <div class="option">
        <input
          type="radio"
          name="type"
          id="absoluteDollars"
          value="absoluteDollars"
          @click="${this.radioButtonHandler}"
        />
        <div class="description">
          <label for="absoluteDollars">Spend Volume</label><br />
          Buyer commits this spend volume to the seller.
        </div>
      </div>
      <div class="option">
        <input
          type="radio"
          name="type"
          id="absoluteUnits"
          value="absoluteUnits"
          @click="${this.radioButtonHandler}"
        />
        <div class="description">
          <label for="absoluteUnits">Unit Volume</label><br />
          Buyer commits this unit volume to the seller.
        </div>
      </div>`;
  }

  radioButtonHandler(event: Event) {
    this.value = (event.target as HTMLInputElement)?.value;
  }
}
